module.exports = __webpack_public_path__ + "static/media/yt.609517bb.svg";